import { Box, Heading, Stack } from "@chakra-ui/react";

import { IconOccupied } from "@ud/icons";
import NewSearchFilter from "scenes/NewHomepage/component/Searchbox/components/NewSearchFilter";

export const OfferDeleted = () => (
  <Box w="100%" bgColor="ud-grey-100">
    <Stack
      alignItems="center"
      pt="200px"
      pb="300px"
      maxW="1000px"
      mx="auto"
      px="10px"
    >
      <IconOccupied boxSize="50px" />
      <Heading variant="h1" pt="20px" pb="50px">
        Inzerát už má zájemce
      </Heading>
      <Heading variant="h3" pb="20px">
        Najděte si jiné atraktivní bydlení:
      </Heading>
      <NewSearchFilter />
    </Stack>
  </Box>
);
